// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import compositeScoreContainerView  from '../../../../templates/MIPS/Dashboard/compositeScoreContainerView';

// Internal Dependencies - models/collections

export default Marionette.ItemView.extend({

    className: 'col s12 phn content-divider',

    initialize: function() {
        this.channel = Backbone.Radio.channel( 'AppChannel' );
        this.app = this.channel.request( 'app' );
        this.listenTo( this.model, 'change:dashboardData', this.render );
    },

    getTemplate: function() {
        return compositeScoreContainerView( this.model );
    },

});
